export default {
  locale: "es",
  name: "Contratos",
  translation: { displayName: "Traducciones" },
  fields: {
    list: [],
    form: [],
  },
};
